import { render } from "./Collapsible.vue?vue&type=template&id=0ba3e21f"
import script from "./Collapsible.vue?vue&type=script&lang=js"
export * from "./Collapsible.vue?vue&type=script&lang=js"
script.render = render

export default script